import { authHeader } from '../helpers/auth-header';
import { config } from '../helpers/config';
import { commonServices } from './common.service';

export const userServices = {
    login,
    logout,
    register,
    getAll,
    getById,
    update,
    delete: _delete,
    getCurrentUser,
    getAllRoles,
    updateCurrentUser,
    sendEmail,
    forgotPassword,
    resetPassword,
    getRoleByName,
    getUserCreatedByParent,
    getUserProfile
};

function resetPassword(userId, newPassword){
    const requestOptions = {
        method: 'GET',
    };

    return fetch(config.apiUrl + '/api/account/ResetPassword/' + userId + '/' + newPassword, requestOptions).then(response => commonServices.handleResponse(response));
}

function forgotPassword(email){
    const requestOptions = {
        method: 'GET',
    };

    return fetch(config.apiUrl + '/api/account/ForgotPassword/' + email, requestOptions).then(response => commonServices.handleResponse(response));
}

function sendEmail(recipientEmail, recipientName, password){
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    var url =encodeURI(config.apiUrl + '/api/account/NewUserEmail/' + recipientEmail+'/'+recipientName+'/'+password, requestOptions);
    
    return fetch(url).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function login(username, password, rememberMe) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: 'grant_type=password&username=' + username + '&password=' + password + '&scope=openid email phone profile offline_access roles'
    };

    return fetch(config.apiUrl + '/connect/token', requestOptions)
        .then(response => commonServices.handleResponse(response), error => commonServices.handleError(error))
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user && user.access_token) {
                // store user details and jwt token in local storage to keep user logged in
                // between page refreshes
                if(rememberMe){
                    localStorage.setItem('tmp', user.access_token);
                }
                else{
                    sessionStorage.setItem('tmp', user.access_token);
                }
            }

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    // localStorage.removeItem('user');
    // sessionStorage.removeItem('user');
    // localStorage.removeItem('userName');
    // localStorage.removeItem('userId');
    // localStorage.removeItem('roleType');
    // localStorage.removeItem('currentChildren');
    localStorage.clear();
    sessionStorage.clear();
    //window.location.reload(true);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/account/users', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/account/users/' + id, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function getCurrentUser() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/account/users/me', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    };

    return fetch(config.apiUrl + '/api/account/users', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function updateCurrentUser(user) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    };

    return fetch(config.apiUrl + '/api/account/users/me', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function update(user) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    };

    return fetch(config.apiUrl + '/api/account/users/' + user.id, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

// prefixed function name with underscore because delete is a reserved word in
// javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/account/users/' + id, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function getUserCreatedByParent(parentId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/account/users/parentId/'+parentId, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

// -------------------------------------Roles-----------------------------------
// --------------------------------
function getAllRoles() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/account/roles', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function getRoleByName(roleName) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/account/roles/name/'+roleName, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function getUserProfile(user) {
    const requestOptions = {
        method: 'POST',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    };

    return fetch(config.apiUrl + '/api/account/getUserProfile', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}


// WEBPACK FOOTER //
// ./src/services/user.service.js